import Reveal from "@/components/Reveal";
import { CalendarDays, Clock3, Check, Flame, MessageCircle } from "lucide-react";

const WHATSAPP_LINK =
  "https://wa.me/595976724321?text=Hola%20Meli%2C%20quiero%20que%20me%20avises%20de%20la%20pr%C3%B3xima%20edici%C3%B3n%20del%20curso";

const schedule = [
  { label: "Sesión 1", day: "Martes 25 de agosto", time: "19:00 a 21:00 h" },
  { label: "Sesión 2", day: "Jueves 27 de agosto", time: "19:00 a 21:00 h" },
  { label: "Sesión 3", day: "Sábado 29 de agosto", time: "16:00 a 18:00 h" },
];

const includes = [
  "Participación en las tres sesiones en vivo",
  "Ejercicios prácticos sobre tu marca",
  "Desarrollo del Mapa CEREBRO",
  "Acceso a la herramienta interactiva de diagnóstico",
];

const Pricing = () => {

  return (
    <section id="inversion" className="relative border-t border-white/10 py-28 md:py-40" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mb-20">
          <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
            Fechas e inversión
          </p>
          <h2 className="max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
            Tres sesiones. <span className="text-stroke-cyan">Ocho módulos</span>
          </h2>
        </Reveal>

        <div className="grid gap-4 md:grid-cols-3">
          {schedule.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="glass h-full p-8" data-testid={`schedule-card-${i + 1}`}>
                <p className="mb-6 font-display text-xs font-bold uppercase tracking-[0.3em] text-magenta">
                  {s.label}
                </p>
                <p className="flex items-center gap-3 font-editorial text-2xl italic text-rosewhite">
                  <CalendarDays className="h-4 w-4 shrink-0 text-neoncyan" /> {s.day}
                </p>
                <p className="mt-3 flex items-center gap-3 text-sm uppercase tracking-[0.2em] text-lilac/80">
                  <Clock3 className="h-4 w-4 shrink-0 text-neoncyan" /> {s.time}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 text-xs uppercase tracking-[0.3em] text-lilac/60" data-testid="schedule-meta">
            Zona horaria GMT-3 · Modalidad online y en vivo · 6 horas totales
          </p>
        </Reveal>

        <div className="mt-24 grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="border border-magenta/40 bg-black/40 p-10 backdrop-blur-xl" data-testid="price-card">
                <div className="border border-orange-500/70 bg-orange-500/15 px-5 py-4" data-testid="cupos-badge">
                  <div className="flex items-center gap-3">
                    <Flame className="h-4 w-4 shrink-0 text-orange-400" />
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-400" data-testid="cupos-label">
                      Sold out
                    </p>
                  </div>
                  <p className="mt-2 text-sm font-bold text-orange-300" data-testid="cupos-restantes">
                    Los 10 cupos se agotaron
                  </p>
                </div>
                <p className="mt-8 text-xs font-medium uppercase tracking-[0.35em] text-lilac/70">Incluye</p>
                <ul className="mt-6 flex flex-col gap-4 border-b border-white/10 pb-8">
                  {includes.map((inc) => (
                    <li key={inc} className="flex items-start gap-3 text-sm text-rosewhite/85">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-neoncyan" />
                      {inc}
                    </li>
                  ))}
                </ul>
                <p className="mt-8 text-xs font-medium uppercase tracking-[0.35em] text-lilac/70">Inversión</p>
                <p className="mt-6 font-display text-6xl font-black tracking-tighter text-rosewhite md:text-7xl">
                  ₲600.000
                </p>
                <p className="mt-2 font-editorial text-2xl italic text-lilac">
                  o USD 100 <span className="text-base not-italic text-lilac/60">(participantes internacionales)</span>
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7" id="pago">
            <Reveal delay={0.12}>
              <div className="glass p-8 md:p-12" data-testid="soldout-panel">
                <p className="font-display text-5xl font-black uppercase tracking-tighter text-orange-400 md:text-7xl">
                  Sold out
                </p>
                <p className="mt-6 max-w-md font-editorial text-2xl italic leading-relaxed text-rosewhite/90">
                  Los 10 cupos de esta edición se agotaron.
                </p>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-lilac/85">
                  Si querés participar de la próxima edición de{" "}
                  <span className="font-editorial italic">El Mapa Invisible de tu Marca</span>,
                  escribinos y te avisamos apenas se abran las inscripciones.
                </p>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="soldout-whatsapp-button"
                  className="mt-8 inline-flex items-center gap-3 bg-magenta px-8 py-4 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-plum transition-colors duration-300 hover:bg-neoncyan"
                >
                  <MessageCircle className="h-4 w-4" /> Avisame de la próxima edición
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
